

export const PROFILES_ENDPOINTS = {
  // Status
  STATUS: { path: `/profiles/status`, method: "GET" },
  
  // Profile Management
  CREATE_PROFILE: { path: `/profiles/create`, method: "POST" },
  GET_PROFILES: { path: `/profiles/profiles`, method: "GET" },
  GET_MY_PROFILE: { path: `/profiles/profile/me`, method: "GET" },
  GET_PROFILE: { path: `/profiles/profile/:userId`, method: "GET" },
  UPDATE_PROFILE: { path: `/profiles/profile/:userId`, method: "PUT" },
  UPDATE_PROFILE_STATUS: { path: `/profiles/profile/:userId/status`, method: "PATCH" },
  DELETE_PROFILE: { path: `/profiles/profile/:userId`, method: "DELETE" },
  REMOVE_PROFILE: { path: `/profiles/profile/:userId/remove`, method: "POST" },
  
  // Looking For Preferences
  UPDATE_LOOKING_FOR: { path: `/profiles/looking-for`, method: "PUT" },
  GET_LOOKING_FOR: { path: `/profiles/looking-for`, method: "GET" },
  
  // Reactions (Likes, Super Likes, etc.)
  ADD_REACTION: { path: `/profiles/reactions/:userId`, method: "POST" },
  REMOVE_REACTION: { path: `/profiles/reactions/:userId/:type`, method: "DELETE" },
  GET_MY_REACTIONS: { path: `/profiles/reactions`, method: "GET" },
  GET_RECEIVED_REACTIONS: { path: `/profiles/reactions/received`, method: "GET" },
  GET_MATCHES: { path: `/profiles/matches`, method: "GET" },
  
  // Private Data Access
  REQUEST_ACCESS: { path: `/profiles/access/request/:userId`, method: "POST" },
  GET_MY_REQUESTS: { path: `/profiles/access/requests`, method: "GET" },
  GET_RECEIVED_REQUESTS: { path: `/profiles/access/requests/received`, method: "GET" },
  UPDATE_REQUEST: { path: `/profiles/access/requests/:requestId`, method: "PUT" },
  GET_PRIVATE_DATA: { path: `/profiles/access/private/:userId`, method: "GET" },
  
  // Block Management
  BLOCK_USER: { path: `/profiles/block/:userId`, method: "POST" },
  UNBLOCK_USER: { path: `/profiles/block/:userId`, method: "DELETE" },
  GET_BLOCKED_USERS: { path: `/profiles/blocked`, method: "GET" },
  
  // Report Management
  REPORT_USER: { path: `/profiles/report/:userId`, method: "POST" },
  GET_MY_REPORTS: { path: `/profiles/reports`, method: "GET" },
  
  // Search & Discovery
  SEARCH_PROFILES: { path: `/profiles/search`, method: "GET" },
  GET_RECOMMENDATIONS: { path: `/profiles/recommendations`, method: "GET" },
  GET_NEARBY: { path: `/profiles/nearby`, method: "GET" },
  INCREMENT_VIEW: { path: `/profiles/profile/:userId/view`, method: "POST" },
  
  // Admin Endpoints
  ADMIN_GET_ALL_PROFILES: { path: `/admin/profiles/profiles`, method: "GET" },
  ADMIN_GET_PROFILE: { path: `/admin/profiles/profiles/:userId`, method: "GET" },
  ADMIN_UPDATE_PROFILE: { path: `/admin/profiles/profiles/:userId`, method: "PUT" },
  ADMIN_DELETE_PROFILE: { path: `/admin/profiles/profiles/:userId`, method: "DELETE" },
  ADMIN_GET_REPORTS: { path: `/admin/profiles/reports`, method: "GET" },
  ADMIN_RESOLVE_REPORT: { path: `/admin/profiles/reports/:reportId`, method: "PUT" },
  ADMIN_GET_STATS: { path: `/admin/profiles/stats`, method: "GET" },
};